import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';

function Preview({ preview }) {
  return (
    <div className="bg-black flex items-center justify-center">
      {preview.loading && <CircularProgress size={30} />}
      {preview.file && <img src={`/preview/${preview.file}`} alt="preview" />}
    </div>
  );
}

Preview.propTypes = {
  preview: PropTypes.object,
};
Preview.defaultProps = {
  preview: {},
};

export default Preview;
